(function Excursions($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('Excursions/reservation', function onload()
		{
			populateExcursions();

			$('#excursion-reservation').on("change", function changeItin() {
				populateExcursions();
			});
		});
	});

	/**
	 * Pull in shore excursions and place html onto the page. Only load shore excursions via ajax once per full page refresh
	 */
	function populateExcursions()
	{
		var $input       = $('#excursion-reservation'),
		    component_id = $input.val(),
		    source       = $input.data('source'),
		    $div         = $('#excursions').find('.excursion-content'),
		    ajax_url     = '/Excursions/getExcursions/' + component_id + '/' + source;

		$div.html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin fa-2x"></i>&nbsp;Loading shore excursions...');

		Adzuki.Ajax.get(ajax_url)
			.then(function _showExcursions(html) {
				$div.html(html);
		});

		$div.on('click', '.port-link', function scrollTo(e) {
			var el = $(this).attr('href');

			e.preventDefault();

			$('html, body').animate({
			    scrollTop: ($(el).offset().top)
			}, 500);
		});
	}
}(jQuery, window.Adzuki || {}));
